import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { DataService } from '../data.service';
import { FileCatalystAPIService } from '../services/file-catalyst-api.service';

import { Subscription, interval } from 'rxjs';
import { saveAs } from 'file-saver';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css'],
})
export class HomeComponent implements OnInit {
  accToggleValue = true;
  // value1;
  TAMessage: string;
  @ViewChild('downloadUtility', { static: false }) downloadUtility: ElementRef;

  hasUploadPrivilege = false;
  constructor(
    private router: Router,
    private dataService: DataService,
    private fcService: FileCatalystAPIService
  ) {}

  ngOnInit(): void {
    // this.dataService.setIsLoading(false);
    this.dataService.getFileTypeCodeRes();
    if (
      localStorage.getItem('acc_enabled') != null &&
      localStorage.getItem('acc_enabled') != undefined
    ) {
      this.accToggleValue =
        localStorage.getItem('acc_enabled') == 'true' ? true : false;
    }
    console.log(
      localStorage.setItem('acc_enabled', this.accToggleValue.toString())
    );

    this.hasUploadPrivilege =
      this.dataService.userPrivilegeInfo.hasUploadPrivilege;

    // if Acceleration Toggle is enabled:
    // check the TA Status
    // this.fcService.getTransferAgentHeartBeat()

    this.dataService.toggleValue = this.accToggleValue;
    console.log('ds acc value ngOninit: ' + this.dataService.toggleValue);
    // let i=0;
    // this.checkTAStatus();
    // this.statusIntvSubc = this.statusInterval.subscribe(() => {
    //   i++;
    //   this.checkTAStatus();
    //   if(i == 10)
    //   {
    //     this.statusIntvSubc.unsubscribe();
    //   }
    // })

    // getFileTypeCode service
    // set the response to dataservice filetypecodes
    console.log('ds acc value ngOninit: ' + this.dataService.toggleValue);
    // let i=0;
    // this.statusIntvSubc = this.statusInterval.subscribe(() => {
    //   i++;
    //   this.checkTAStatus();
    //   if(i == 1)
    //   {
    //     this.statusIntvSubc.unsubscribe();
    //   }
    // })
    // this.openTAModal();
    if (this.dataService.toggleValue) {
      this.checkTAStatus();
      // this.openTAModal();
    }
  }

  changed() {
    this.accToggleValue = !this.accToggleValue;
    this.dataService.setToggleValue(this.accToggleValue);
    // this.dataService.toggleValue = !this.accToggleValue
    console.log('ds acc value: ' + this.dataService.getToggleValue());
    localStorage.setItem('acc_enabled', this.accToggleValue.toString());
    // this.router.navigate([''],{ skipLocationChange: true })
    console.log('reloading the screen');
    window.location.reload();
  }
  downloadFile() {
    // const link = document.createElement('a');
    // link.setAttribute('target', '_self');
    // link.setAttribute('href', 'assets/install_fc_transferagent_3.8.2.zip');
    // link.setAttribute('download', `install_fc_transferagent_3.8.2.zip`);
    // document.body.appendChild(link);
    // link.click();
    saveAs(
      'assets/install_fc_transferagent_3.8.9_v3.zip',
      'FileCatalyst_TransferAgent'
    );
    // link.remove();
  }

  checkTAStatus() {
    console.log('In check');
    let statusIntvSubc: Subscription;
    let statusInterval = interval(2000);

    statusIntvSubc = statusInterval.subscribe(() => {
      this.fcService.getTransferAgentHeartBeat().subscribe(
        (response) => {
          console.log('response from heart beat service ', response);
          if (response.status != 'OK') {
            // console.log('Open File Catalyst')
            // window.open("filecatalyst:",'_self');
            this.openTAModal();
            // Installed, but not turned on
            // Not installed
          } else {
            statusIntvSubc.unsubscribe();
            this.closeTAModal();
          }
        },
        (error) => {
          console.log('error from heart beat service ', error);
          // console.log('Open File Catalyst')
          // window.open("filecatalyst:",'_self');
          this.openTAModal();
          // console.log('error from heart beat service ',error)
          // let flag = this.dataService.getToggleValue()
          // if(error.status != "OK" && flag==true)
          // {
          //   this.openTAModal();
          // }else
          // {
          //   this.closeTAModal();
          // }
        }
      );
    });
  }
  continueWA() {
    this.dataService.setToggleValue(false);
    this.accToggleValue = false;
    // if(localStorage.getItem())
    console.log(
      'Local storate acc_enabled ',
      localStorage.getItem('acc_enabled')
    );
    localStorage.setItem('acc_enabled', this.accToggleValue.toString());
    // this.router.navigate([['home'],{skipLocationChange:true}])
    window.location.reload();
  }

  openTAModal() {
    console.log('Opening TA Modal');
    let btn = document.getElementById('downloadUtility');
    btn.click();
  }

  closeTAModal() {
    console.log('Closing TA Modal');
    let clsBtn = document.getElementById('closeModal');
    clsBtn.click();
  }
}
